define([
    'text!cooperate/component/item-project.html',
    'cooperate/mixin/form',
    'cooperate/component/enum-select'
], function(
    tpl,
    FormMixin,
    EnumSelect
){
    return {
        template: tpl,
        mixins: [FormMixin],
        components: {
            EnumSelect: EnumSelect
        },
        methods: {
            resetForm: function(){
                this.form = {
                    type: 1,
                    companyName: '',
                    projectName: '',
                    city: '',
                    budget: '',
                    inTime: '',
                    contact: '',
                    position: '',
                    tel: '',
                    email: '',
                    attch: '',
                    remark: ''
                };
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./cooperate/component/item-project.js
// module id = 205
// module chunks = 0